import { combineReducers } from 'redux';

import disqualification from './disqualification';
import customer from './customer';
import request from './request';

const rootReducer = combineReducers({
  customer,
  disqualification,
  request
});

export default rootReducer;
